<ng-container *transloco="let t; prefix: 'DataSharing'">
  <div>
    @if (isAuthorized) {
    @if (sharedData.length === 0) {
    <div>
      <div class="msi-margin-s">
        <msi-callout [type]="infoCalloutType" [title]="t('text.calloutNoShared')">
          <div calloutContent>
            {{ t('text.noSharing') }}
          </div>
        </msi-callout>
      </div>
    </div>
    }
    <div *ngIf="!isBusy">
      <span class="msi-h2 msi-bold">{{ t('text.dataSharing') }}</span>
      <div *ngIf="!isBusy">
        <div style="display: flex; justify-content: space-between; align-items: center; margin: 10px 0;">
          <span class="msi-h4 msi-bold">{{ t('label.externalOrganization') }}</span>
          <button pButton (click)="onAddCustomerClicked()" [disabled]="isSuperAdmin">{{ 'DataSharing.buttons.add' |
            transloco }}</button>
        </div>
      </div>
      <div id="table-wrapper">
        <p-table [value]="sharedData" id="org-table" [style]="{ width: '100%' }">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" style="text-align: left;">{{ t('label.id') }}</th>
              <th scope="col" [attr.aria-label]="t('label.actions')"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-idx="rowIndex">
            <tr>
              <td>
                <span class="org-name">{{ item }}</span>
              </td>
              <td style="display: flex; justify-content: flex-end;">
                <p-button (click)="onRemoveCustomerClicked(idx)" [disabled]="isSuperAdmin"
                  [ariaLabel]="t('label.removeOrganization')">
                  <ng-template pTemplate="icon">
                    <msi-icon name="ic_trash" [size]="18"></msi-icon>
                  </ng-template>
                </p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    } @else {
    <div class="msi-margin-s">
      <msi-callout [type]="errorCalloutType" [title]="t('text.calloutUnauthorized')">
        <p>{{ t('text.unauthorized') }}</p>
      </msi-callout>
    </div>
    }
  </div> 
</ng-container>